import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'

import Routes from './routes'
import { ThemeProvider } from 'styled-components/macro'
import { ThemeProvider as MaterialThemeProvider } from '@material-ui/core/styles'
import theme from 'styles/theme'
import materialTheme from 'styles/materialTheme'
import GlobalStyles from 'styles/global'
import { Header } from 'components/Header'
import './assets/fonts/fonts.css'
import MuiPickersUtilsProvider from '@material-ui/pickers/MuiPickersUtilsProvider'
import DateFnsUtils from '@date-io/date-fns'
import deLocale from 'date-fns/locale/pt-BR'
import { SnackbarProvider } from 'material-ui-snackbar-provider'
import SnackBar from 'components/SnackBar'

ReactDOM.render(
  <React.StrictMode>
    <MaterialThemeProvider theme={materialTheme}>
      <ThemeProvider theme={theme}>
        <Header />
        <SnackbarProvider SnackbarComponent={SnackBar}>
          <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
            <Routes />
          </MuiPickersUtilsProvider>
        </SnackbarProvider>
        <GlobalStyles />
      </ThemeProvider>
    </MaterialThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
